const getResultsByIndex = (allSearchResults, indexName)=>{
    var ref;
    var ref1;
    return (ref1 = (ref = allSearchResults.find((searchResult)=>searchResult.indexId === indexName
    )) === null || ref === void 0 ? void 0 : ref.results) !== null && ref1 !== void 0 ? ref1 : null;
};

export { getResultsByIndex };
//# sourceMappingURL=get-results-by-index.js.map
